import { capitalizeString } from '@strata/helper-functions';
import { TextAreaFormik } from '@strata/react-inputs';
import { HomeScreen, UrgentMessagesSection } from '@strata/react-page-templates';
import { RadioButtonGroupFormik } from '@strata/react-radio-button-group';
import { validationStrings } from '@strata/strata-ui-strings';
import dayjs from 'dayjs';
import * as Yup from 'yup';

import {
    ApplicationInputs,
    DisplayInput,
    MessageCategoryInput,
} from 'pages/homeScreenMessaging/HomeScreenFormInputs';
import { HomeScreenMessageForm } from 'pages/homeScreenMessaging/HomeScreenMessageForm';

const formContent = () => (
    <>
        <MessageCategoryInput label="Message Type" />
        <TextAreaFormik id="message" label="Message" required />
        <RadioButtonGroupFormik
            name="intent"
            label="Intent"
            options={Object.values(UrgentMessagesSection.Intent).map((intent) => ({
                value: intent,
                text: capitalizeString(intent),
            }))}
            required
        />
        <ApplicationInputs />
        <DisplayInput />
    </>
);

const previewContent = (values) => (
    <UrgentMessagesSection
        urgentMessages={[
            {
                publish_date: values.publish_date ?? dayjs().toISOString(),
                message: values.message || 'Urgent message text.',
                intent: values.intent,
            },
        ]}
    />
);

export const UrgentMessageDetails = () => (
    <HomeScreenMessageForm
        formTitle="Urgent Message"
        listPageUrl="/home-screen-messaging/urgent-messages"
        formatInitialValues={(message) => ({
            ...MessageCategoryInput.initialValues(message),
            message: message?.message,
            intent: message?.intent ?? UrgentMessagesSection.Intent.WARNING,
            ...ApplicationInputs.initialValues(message),
            ...DisplayInput.initialValues(message),
        })}
        validationSchema={Yup.object({
            ...MessageCategoryInput.validationSchema,
            message: Yup.string().required(validationStrings.requiredField.errorMessage),
            intent: Yup.string().required(validationStrings.requiredField.errorMessage),
            ...ApplicationInputs.validationSchema,
            ...DisplayInput.validationSchema,
        })}
        formatSubmitBody={(values) => ({
            message_type: HomeScreen.MessageType.URGENT,
            ...MessageCategoryInput.submitValues(values),
            message: values.message,
            intent: values.intent,
            ...ApplicationInputs.submitValues(values),
            ...DisplayInput.submitValues(values),
        })}
        formContent={formContent}
        previewContent={previewContent}
    />
);
